export default __webpack_public_path__ + "static/healthcare-fraud-prevention-img-2-e830920b94d41b55b361b095bb7c3f71.svg";